import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { ArticleItem } from '../../../stores/ArticleStore';
import { AppConfigurationStore } from '../../../stores/AppConfigurationStore';
import { UIHelper } from '../../../utils/UIHelper';

interface ArticlePropertyClassProps {
    articleItem: ArticleItem;
    selectedBasketIdsCount: number;
}

interface ArticlePropertyClassState {
    open: boolean;
}

/**
 * Child of PropertyEditor-Component
 */
export class ArticlePropertyClass extends BaseComponent<ArticlePropertyClassProps, ArticlePropertyClassState> {
    public componentWillMount(): void {
        this.setState({open: false});
    }

    public render(): JSX.Element | null {
        if (
            this.props.selectedBasketIdsCount !== 1 ||
            this.props.articleItem == null ||
            this.props.articleItem.properties == null
        ) {
            return null;
        }

        const subInfos: Array<JSX.Element> = this.getArticleSubInformations(this.props.articleItem.properties.article);
        return (
            <div className={'core-config' + (this.state.open ? ' active' : '')}>
                <div className="core-config-header" onClick={this.toggle}>{t('Article Information')}</div>
                <div className="core-config-items">
                {subInfos}
                </div>
            </div>
        );
    }

    protected toggle = (): void => {
        this.setState(jQuery.extend({}, this.state, {open: !this.state.open}));
    };

    protected getArticleSubInformations(articleProperties: egr.wcf.eaiws.basket.ArticleProperties | undefined): Array<JSX.Element> {
        if (articleProperties == null) {
            return [];
        }
        const result: Array<JSX.Element> = [];
        if (articleProperties.manufacturerName) {
            result.push(
                <div className="core-config-item core-config-item-disabled" key="manufacturer">
                    <div className="core-property">{t('Manufacturer')}:&nbsp;{articleProperties.manufacturerName}</div>
                </div>
            );
        }
        if (articleProperties.seriesName) {
            result.push(
                <div className="core-config-item core-config-item-disabled" key="seriesname">
                    <div className="core-property">{t('Product line')}:&nbsp;{articleProperties.seriesName}</div>
                </div>
            );
        }
        if (articleProperties.baseArticleNumber && AppConfigurationStore.getState().showArticleNumbers) {
            result.push(
                <div className="core-config-item core-config-item-disabled" key="basearticlenumber">
                    <div className="core-property">{t('Article code')}:&nbsp;{articleProperties.baseArticleNumber}</div>
                </div>
            );
        }
        if (articleProperties.longText) {
            result.push(
                <div className="core-config-item core-config-item-disabled" key="longtext">
                    <div className="core-property">{UIHelper.multilineTextToArray(articleProperties.longText).map((line: string, index: number) => {
                        return (
                            <div key={index}>{line}</div>
                        );
                    })}</div>
                </div>
            );
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/propertyeditor/ArticlePropertyClass.tsx